<template>
  <div class="tomb_page">
    <div
      class="head-topbar lite-page-top linebottom sticky"
      style="background: rgb(255, 255, 255);"
    >
      <div class="topbar-left" @click="goto('/my')"><i class="icon-arrow-left"></i></div>
      <div class="topbar-main"><h4>我的留言</h4></div>
      <div class="topbar-right"></div>
    </div>
    <div>
      <div class="tomb-item mt" v-for="(item, index) in messageList" :key="index">
        <span>
          <div class="item-slide pd15" id="msg_33171" style="display: block;">
            <div class="item-head">
              <div class="msg-txt TextChangeToTwoLines">{{ item.content }}</div>
            </div>
            <div class="item-time">
              <span>{{ getDateFormatter(item.lastUpdateDate) }}</span>
            </div>
            <div
              class="ct-bottom flex flex_center"
              style="margin-top: 0.9rem; padding-bottom: 0px;"
            >
              <div class="ct-tomb">
                <i class="icon-tomb"></i><span class="name">{{ item.hallInfo.title }}</span>
              </div>
              <div style="display: flex;">
                <div class="ct-iconf ct-iconf-edit" @click="preUpdateMessage(item.id)">
                  <i style="width:1.6rem;"></i>
                </div>
                <div class="ct-iconf ct-iconf-del" @click="delConfirm(id)">
                  <i style="width:1.8rem;"></i>
                </div>
                <div class="ct-iconf ct-iconf-close" @click="open">
                  <i style="width:1.8rem;"></i>
                </div>
                <!-- <div class="ct-iconf ct-iconf-open" @click="close"><i></i></div> -->
              </div>
            </div>
          </div>
        </span>
      </div>
      <div class="adm-infinite-scroll">
        <div><span>没有更多数据了</span></div>
      </div>
    </div>
    <van-action-sheet v-model="editFlag" title="修改留言">
      <div class="content">
        <div class="detail-comment-editor" style="padding-top: 2.5rem; padding-bottom: 2rem;">
          <div class="flex-col focus">
            <div class="textarea-box">
              <textarea
                rows="1"
                placeholder=""
                class="textarea"
                v-model="messageForm.content"
              ></textarea>
              <div class="flex-row detail-emoji-main">
                <span class="detail-iconf detail-iconf-emote"></span>
              </div>
            </div>
            <div
              class="publish-dynamic-plugins"
              style="margin-top: 0px; margin-bottom: 1rem;"
            ></div>
            <div class="comment-btn bg-orange common-btn-submit">确定</div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'myCreat',
  data() {
    return {
      editFlag: false,
      messageForm: {
        id: null,
        content: null,
      },
      messageList: [],
      messageTotal: 0,
    }
  },
  methods: {
    delConfirm(id) {
      var that = this
      this.$dialog
        .confirm({
          message: '是否确认删除？',
        })
        .then(() => {
          // on confirm
          that.deleteMessage(id)
        })
        .catch(() => {
          // on cancel
        })
    },
    open() {},
    close() {},
    goto(str) {
      this.$router.push({ path: str })
    },
    getDateFormatter(value) {
      if (value) {
        return moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
      } else {
        return ''
      }
    },
    queryMyMessagePage() {
      var that = this
      this.$queryPage(
        'HallMessage',
        { myId: this.$store.getters.userId, 'hallInfo.id': 'isnotnull' },
        ['id,content,createDate,lastUpdateDate,hallInfo.id,hallInfo.title'],
        function(res) {
          that.$fill(that.messageList, res['data'])
        }
      )
    },
    preUpdateMessage(id) {
      this.editFlag = true
      var that = this
      this.$queryOne(
        'HallMessage',
        { myId: this.$store.getters.userId, id: id },
        ['id,content,createDate,lastUpdateDate'],
        function(res) {
          that.$fill(that.messageForm, res['data'])
          that.queryMyMessagePage()
        }
      )
    },
    updateMessage() {
      var that = this
      this.$submit('HallMessage', this.messageForm, function(res) {
        if (res['code'] == '1') {
          that.queryMyMessagePage()
        }
      })
    },
    deleteMessage(id) {
      var that = this
      this.$invalid('HallMessage', { myId: this.$store.getters.userId, id: id }, function(res) {
        if (res['code'] == '1') {
          that.queryMyMessagePage()
        }
      })
    },
  },
  mounted() {
    this.queryMyMessagePage()
  },
  created() {},
}
</script>

<style>
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}

.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}

.head-topbar.fixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}

.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/left.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}

.head-topbar .topbar-right .icon-more {
  background: url(../../../assets/jnt/more.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 3.365vw;
  width: 4.125vw;
}

.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}

.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}

.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}

.head-topbar .topbar-btn {
  background: #e4803c;
  color: #fff;
  padding: 0.5rem 1.2rem;
  border-radius: 20px;
  font-size: 1.3rem;
}
.adm-infinite-scroll {
  color: var(--adm-color-weak);
  padding: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}
.TextChangeToOneLines {
  -webkit-line-clamp: 1;
  /*! autoprefixer: off*/
}

.TextChangeToOneLines,
.TextChangeToTwoLines {
  display: -webkit-box !important;
  overflow: hidden;
  word-break: break-all;
  -webkit-box-orient: vertical;
}

.TextChangeToTwoLines {
  -webkit-line-clamp: 2;
  /*! autoprefixer: off*/
}

.TextChangeToThreeLines {
  -webkit-line-clamp: 3;
  /*! autoprefixer: off*/
}

.TextChangeToFourLines,
.TextChangeToThreeLines {
  display: -webkit-box !important;
  overflow: hidden;
  word-break: break-all;
  -webkit-box-orient: vertical;
}

.TextChangeToFourLines {
  -webkit-line-clamp: 4;
  /*! autoprefixer: off*/
}

.TextChangeToSevenLines {
  display: -webkit-box !important;
  -webkit-line-clamp: 7;
  overflow: hidden;
  word-break: break-all;
  /*! autoprefixer: off*/
  -webkit-box-orient: vertical;
}

.msg_list-row .list-view-section-body {
  padding: 10px 0;
}

.msg_list-row .am-list-body:after,
.msg_list-row .am-list-body:before {
  background-color: #fff !important;
}
.item-slide .ct-bottom .ct-tomb .icon-tomb {
  width: 18px;
  height: 18px;
  background: url(../../../assets/jnt/feed.png) no-repeat;
  background-size: 100% 100%;
  display: block;
  margin-right: 8px;
}

.tomb-advert {
  padding: 0 15px;
  margin-top: 20px;
}

.tomb-advert .advert-box {
  box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.05);
}

.tomb-advert .advert-img {
  width: 100%;
}

.item-slide .item-head {
  position: relative;
  display: flex;
  overflow: hidden;
  height: auto;
  width: 100%;
  background-color: #fff;
  flex-direction: row;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 0.9rem;
}

.item-slide .item-head .txt {
  flex: 1;
  overflow: hidden;
  color: #999;
}

.item-slide .item-head .msg-txt {
  flex: 1;
  overflow: hidden;
  color: #333;
  font-size: 1.2rem;
}

.item-slide .item-head .msg-more-btn {
  background: url(../../../assets/jnt/more1.png) no-repeat;
  background-size: 100% 100%;
  width: 32px;
  height: 25px;
}

.item-slide .item-head .status {
  position: relative;
  display: flex;
}

.item-slide .item-head .status.success {
  color: #33ae52;
}

.item-slide .item-head .status.fail {
  color: #b20000;
}

.item-slide .item-head .status.watting {
  color: #b16d4e;
}

.item-slide .item-head .status.cancel {
  color: #999;
}

.item-slide .item-time {
  color: #999;
  font-size: 1.1rem;
}

.item-slide .ct-bottom {
  justify-content: space-between;
  -webkit-justify-content: space-between;
}

.item-slide .ct-bottom .ct-tomb {
  min-height: 3rem;
  max-width: 21rem;
  display: flex;
  align-items: center;
  background: rgba(228, 128, 60, 0.15);
  padding: 6px 13px;
  box-sizing: border-box;
  border-radius: 15px;
}

.item-slide .ct-bottom .ct-tomb .icon-tomb {
  width: 2rem;
  height: 2rem;
  background: url(../../../assets/jnt/feed.png) no-repeat;
  background-size: 100% 100%;
  display: block;
  margin-right: 8px;
}

.item-slide .ct-bottom .ct-tomb .name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #e4803c;
  flex: 1;
}

.item-slide .item-msg-con {
  background: #f7f7f7;
  border-radius: 8px;
  padding: 7px;
  position: relative;
}

.item-slide .item-msg-arrow:after {
  content: ' ';
  display: inline-block;
  height: 11px;
  width: 7px;
  background: url(../../../assets/jnt/right.png);
  background-size: 100% 100%;
  position: absolute;
  top: 50%;
  margin-top: -5px;
  right: 10px;
}

.tomb-item .item-img {
  background: #f4f4f4;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  width: 8.181rem;
  height: 9.818rem;
}

.tomb-item .item-img-pray {
  background: #eee;
  border-radius: 0.68rem;
  overflow: hidden;
  position: relative;
  width: 4.2rem;
  height: 4.2rem;
  padding: 6px;
  display: flex;
  align-items: center;
}

.tomb-item .item-img-pray img {
  width: 100%;
}

.index-head .sheet-main .item-head-img img,
.tomb-item .item-img img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  position: absolute;
  width: 100%;
  height: 100%;
  vertical-align: top;
  -o-object-fit: cover;
  object-fit: cover;
}

.tomb-item .item-img img {
  height: 100%;
  width: 100%;
}

.tomb-item .item-desc {
  -ms-flex-direction: column;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 10px;
  width: calc(100% - 8.909rem);
  margin-top: 0.5rem;
}

.tomb-item .item-desc .title {
  color: #333;
  font-size: 1.4rem;
  line-height: 1.4;
  margin-top: -3px;
  position: relative;
  padding: 0 !important;
}

.tomb-item .item-desc .title .time {
  color: #999;
  float: right;
  font-weight: 400 !important;
}

.tomb-item .item-desc .title .txt-birth {
  background: #e4803c;
}

.tomb-item .item-desc .title .txt-birth,
.tomb-item .item-desc .title .txt-dear {
  font-size: 0.9rem;
  color: #fff;
  line-height: 1.454rem;
  display: inline-block;
  padding: 0 4px;
  border-radius: 2.5px;
  margin-left: 7px;
  position: relative;
  top: -1px;
}

.tomb-item .item-desc .title .txt-dear {
  background: #999;
}

.tomb-item .item-desc .price {
  position: absolute;
  right: 0;
  top: 0;
}

.tomb-item .item-desc .intro {
  color: #666;
  font-size: 1.272rem;
  line-height: 22px;
  margin-top: -3px;
}

.tomb-item .item-desc .birthday {
  margin: 0.909rem 0 0.636rem;
}

.tomb-item .item-desc .birthday,
.tomb-item .item-desc .time {
  color: #666;
  font-size: 1.272rem;
  line-height: 1.272rem;
  font-family: PingFangSC-Regular, PingFang SC;
}

.tomb-item .item-desc .time {
  margin-bottom: 1.181rem;
}

.tomb-item .item-desc .intro-bot {
  -ms-flex-align: end;
  -ms-flex-pack: justify;
  -webkit-align-items: flex-end;
  -webkit-justify-content: space-between;
  align-items: flex-end;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.tomb-item .item-desc .intro-bot .bot-counts {
  color: #666;
  font-size: 1.2rem;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
}

.tomb-item .item-desc .intro-bot .bot-counts .view {
  margin-right: 10px;
}

.tomb-item .item-desc .intro-bot .bot-counts .love {
  margin-right: 2.272rem;
}

.tomb-item .item-desc .intro-bot .bot-counts .love,
.tomb-item .item-desc .intro-bot .bot-counts .view {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  align-items: center;
}

.tomb-item .item-desc .intro-bot .bot-counts .icon-view {
  height: 20px;
  width: 20px;
  background: url(../../../assets/jnt/view.png) no-repeat;
  background-size: 100% 100%;
  margin-right: 2px;
  position: relative;
  top: 1px;
}

.tomb-item .item-desc .intro-bot .bot-counts .icon-love {
  height: 20px;
  width: 20px;
  background: url(../../../assets/jnt/hot.png) no-repeat;
  position: relative;
  background-size: 100% 100%;
  margin-right: 2px;
}

.tomb-item .item-desc .intro-bot .bot-counts .love span,
.tomb-item .item-desc .intro-bot .bot-counts .view span {
  position: relative;
  top: 1.5px;
}

.tomb-item .item-desc .intro-bot .nav-btn {
  -ms-flex-align: end;
  align-items: flex-end;
  display: -ms-flexbox;
  display: flex;
  font-size: 12px;
  line-height: 10px;
  overflow: visible;
  position: relative;
  top: 5px;
}

.tomb-item .item-desc .intro-bot .nav-btn .icon {
  display: -ms-flexbox;
  display: flex;
}

.tomb-item .item-desc .intro-bot .nav-btn .icon-edit {
  margin-right: 0.9rem;
}

.tomb-item .item-desc .intro-bot .nav-btn .icon-edit i {
  background: url(../../../assets/jnt/edit2.png) no-repeat;
  background-size: 100%;
}

.tomb-item .item-desc .intro-bot .nav-btn .icon-del i {
  background: url(../../../assets/jnt/del.png) no-repeat;
  background-size: 100%;
}

.tomb-item .item-desc .intro-bot .nav-btn .icon i {
  width: 1.45rem;
  height: 1.45rem;
}

.tomb-item .item-desc .intro-bot .nav-btn .love .txt2 {
  font-size: 15px;
}

.tomb-item .item-desc .intro-bot .green {
  color: #2fc653;
}

.tomb-item .item-desc .intro-bot .red {
  color: #f82f4b;
}

.tomb-item .item-desc .intro-bot .gray {
  color: #c7c7c7;
}

.tomb-item .item-desc .intro-bot .pray-time {
  font-size: 1.1rem;
  color: #999;
}

.tomb-item .item-desc .intro-bot .arrow-right {
  font-size: 1.1rem;
  color: #e4803c;
}

.tomb-item .item-desc .intro-bot .arrow-right:after {
  width: 5.5px;
  height: 8px;
  content: '';
  display: inline-block;
  background: url(../../../assets/jnt/right4.png) no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
}

.tomb-item .item-desc .intro-bot .btn-pay {
  border: 1px solid #b16d4e;
  color: #b16d4e;
  padding: 3px 6px;
  border-radius: 12px;
}

.tomb-item .item-r .appointment-btn {
  width: 4rem;
  text-align: center;
  background: #b26e4e;
  color: #fff;
  padding: 8px 3px;
  border-radius: 7px;
}

.tomb-main .tomb-more {
  background: #fff;
  padding: 15px;
}

.tomb-main .tomb-more .btn {
  background: #fbefe7;
  line-height: 45px;
  border-radius: 8px;
  color: #e4803c;
  text-align: center;
  font-size: 1.3rem;
  position: relative;
}

.tomb-main .tomb-more .btn .arrow-right {
  position: relative;
  top: -1px;
}

.tomb-main .tomb-more .btn .arrow-right,
.tomb-main .tomb-more .btn.arrow-right:after {
  background: url(../../../assets/jnt/right3.png) no-repeat;
  background-size: 100% 100%;
  width: 6.5px;
  height: 10px;
  display: inline-block;
  margin-left: 5px;
}

.tomb-main .tomb-more .btn.arrow-right:after {
  content: '';
}

.tomb-main .tomb-more .btn.arrow-right-jiandang100:after {
  content: '';
  background: url(../../../assets/jnt/right2.png) no-repeat;
  background-size: 100% 100%;
  width: 6.5px;
  height: 10px;
  display: inline-block;
  margin-left: 5px;
}

.tomb-main .tomb-nav {
  list-style: none;
  font-size: 1.4rem;
  padding: 0.685rem;
  background: #fff;
  overflow: hidden;
  padding-left: 0;
  font-family: PingFangSC-Regular\, PingFang SC;
}

.tomb-main .tomb-nav .tomb-nav-slide {
  width: auto;
  padding: 0 5px;
  letter-spacing: 2px;
  text-align: center;
  color: #333;
  padding-right: 0.5rem;
  position: relative;
}

.tomb-main .tomb-nav .active span {
  transform: scale(1.05);
  color: #e4803c;
  background: #fbeddd;
  padding: 0.4rem 0.9rem;
  border-radius: 15px;
}

.tomb-main .tomb-nav .tomb-nav-slide span {
  display: block;
  padding: 0 0.9rem;
  line-height: 2.4rem;
  padding-top: 1px;
  padding-left: 1rem;
}

.tomb-tab {
  background: #fff;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}

.tomb-tab-shadow:after {
  content: '';
  box-shadow: 0 3px 10px 6px rgba(0, 0, 0, 0.04);
}

.listing-box {
  padding: 0;
}

.tomb-item .am-list-body {
  background-color: #f4f4f4;
  padding-top: 15px;
}

.tomb-item .am-list-body:before {
  background-color: inherit !important;
}

.private-wrap .am-list-body {
  background-color: #fff;
}

.search-box {
  position: relative;
  padding: 8px 15px;
  padding-top: 10px;
  display: flex;
  display: -webkit-flex;
  box-sizing: border-box;
}
.ct-bottom {
  margin-top: 0.5rem;
  padding-bottom: 1.2rem;
  justify-content: space-between;
  -ms-flex-align: end;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
}

.ct-bottom div:last {
  border: none;
}

.ct-bottom .ct-iconf {
  font-size: 1.8rem;
  line-height: 1.8rem;
  color: #999;
  min-width: 3.225rem;
}

.ct-bottom .ct-iconf .txt {
  color: #999;
  display: inline-block;
  vertical-align: middle;
}

.ct-bottom .ct-iconf-like i {
  background-image: url(../../../assets/jnt/xin1-.png);
}

.ct-bottom .ct-iconf-liked i,
.ct-bottom .ct-iconf-like i {
  background-size: 100%;
  width: 1.4rem;
  height: 1.4rem;
  display: inline-block;
  margin-right: 0.1rem;
}

.ct-bottom .ct-iconf-liked i {
  background-image: url(../../../assets/jnt/xin1.png);
}

.ct-bottom .ct-iconf-comment i {
  background-image: url(../../../assets/jnt/msg.png);
}

.ct-bottom .ct-iconf-comment i,
.ct-bottom .ct-iconf-delete i {
  background-size: 100%;
  width: 1.4rem;
  height: 1.4rem;
  display: inline-block;
  margin-right: 1rem;
}

.ct-bottom .ct-iconf-delete i {
  background-image: url(../../../assets/jnt/del.png);
}

.ct-bottom .ct-iconf-edit i {
  background-image: url(../../../assets/jnt/edit2.png);
  height: 1.55rem;
}
.ct-bottom .ct-iconf-del i {
  background-image: url(../../../assets/jnt/del.png);
  height: 1.8rem;
}
.ct-bottom .ct-iconf-open i {
  background-image: url(../../../assets/jnt/open.png);
  height: 1.8rem;
}
.ct-bottom .ct-iconf-close i {
  background-image: url(../../../assets/jnt/close1.png);
  height: 1.8rem;
}

.ct-bottom .ct-iconf-edit i,
.ct-bottom .ct-iconf-more i,
.ct-bottom .ct-iconf-del i,
.ct-bottom .ct-iconf-open i,
.ct-bottom .ct-iconf-close i {
  background-size: 100%;
  width: 1.4rem;
  display: inline-block;
  margin-right: 1rem;
}

/* .ct-bottom .ct-iconf-more i {
  background-image: url(../../../assets/jnt/more2.png);
  height: 4.5px;
  background-repeat: no-repeat;
}

.ct-bottom .ct-iconf-del i {
  background-image: url(../../../assets/jnt/del.png);
  height: 4.5px;
  background-repeat: no-repeat;
}
.ct-bottom .ct-iconf-open i {
  background-image: url(../../../assets/jnt/open.png);
  height: 4.5px;
  background-repeat: no-repeat;
}
.ct-bottom .ct-iconf-close i {
  background-image: url(../../../assets/jnt/close.png);
  height: 4.5px;
  background-repeat: no-repeat;
} */

.ct-bottom .ct-text-detail {
  color: #e4803c;
}

.ct-bottom .ct-text-detail:after {
  width: 5.5px;
  height: 8px;
  content: '';
  display: inline-block;
  background: url(../../../assets/jnt/right4.png) no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
}
.flex_center {
  align-items: center;
  -webkit-box-pack: justify;
}
.flex {
  display: flex;
}
.tomb-item .item-slide {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 12px;
  margin-left: 12px;
  margin-right: 12px;
  display: flex;
}
.pd15 {
  padding: 15px;
}
.mt {
  margin-top: 12px;
}
.detail-comment-editor {
  min-height: 3.125rem;
  color: #333;
  z-index: 995;
  border-top-width: 1px;
  border-right-width: 0;
  border-bottom-width: 0;
  border-left-width: 0;
  border-color: transparent;
  border-style: solid;
}

.detail-comment-editor .textarea-box {
  padding: 1rem;
  position: relative;
}

.detail-comment-editor .flex-row {
  padding-left: 15px;
  padding-bottom: 10px;
}

.detail-comment-editor .flex-row .detail-iconf-emote {
  background: url(../../../assets/jnt/weixiao.png) no-repeat;
  background-size: 100%;
  width: 2.2rem;
  height: 2.2rem;
  display: block;
}

.detail-comment-editor .textarea-box .textarea {
  height: 12.5rem;
  border: none;
  width: 100%;
  padding-left: 10px;
  padding-top: 10px;
  font-size: 1.3rem;
  background: #f4f4f4ff;
  border-radius: 0.5rem;
}

.detail-comment-editor .textarea-box .detail-emoji-main {
  position: absolute;
  bottom: 1rem;
  right: 2rem;
}

.detail-comment-editor .textarea-box .btn-send {
  -webkit-appearance: none;
  outline: 0;
  border: 0;
  background: none;
  font-size: 1.25rem;
  text-align: center;
  display: inline-block;
  line-height: 1.8125rem;
  padding: 6px 8px;
  margin-left: 0.75rem;
  background-color: #71c2fa;
  border-radius: 0.325rem;
  color: #fff;
  position: absolute;
  bottom: 11px;
  right: 8px;
}

.detail-comment-editor .t-p-face-enter {
  transform-origin: left 0;
  transform: scaley(0);
  opacity: 0;
  transition-property: transform opacity ease;
  transition: all 0.2s;
}

.detail-comment-editor .t-p-face-enter.t-p-face-enter-active {
  transform: scaley(1);
  opacity: 1;
}

.detail-comment-editor .t-p-face-leave {
  transform-origin: 0 0;
  transform: scaley(1);
  opacity: 1;
  transition-property: transform opacity ease;
  transition: all 0.2s;
}

.detail-comment-editor .t-p-face-leave.t-p-face-leave-active {
  transform: scaley(0);
  opacity: 0;
}

.detail-comment-editor .comment-btn {
  margin-left: 1rem;
  margin-right: 1rem;
  width: auto;
}
.common-btn-submit {
  height: 4rem;
  background: #15a892;
  width: 100%;
  border-radius: 2rem;
  text-align: center;
  line-height: 4rem;
  font-size: 1.5rem;
  color: #fff;
}
</style>
